<template>
  <div>
    <van-dialog
      v-model="showDialog"
      class="dialog"
      :showCancelButton="showCancelButton"
      :confirmButtonText="confirmButtonText"
      confirmButtonColor="#0074E8"
      @confirm="confirm"
      @cancel="cancel"

    >
      <van-icon :name="icon" :color="iconColor" size="3rem" />
      <p>{{ text }}</p>
    </van-dialog>
  </div>
</template>
  
  <script>
import { icon, Dialog } from "vant";
export default {
  name: "dialogTips",
  components: {
    vanIcon: icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "warning",
    },
    iconColor: {
      type: String,
      default: "red",
    },
    text: {
      type: String,
      default: "",
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: "确定",
    },
  },

  watch: {
    show(val) {
      this.showDialog = val;
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
  
  <style scoped>
.dialog {
  width: 80%;
  text-align: center;
  padding: 1rem;
}
</style>
  